import {
  Box,
  Center,
  Divider,
  Heading,
  Text,
  List,
  ListItem,
  ListIcon,
  UnorderedList,
} from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';

import React from 'react';
import IntroduceUrlCopyButton from '~/components/organisms/IntroduceUrlCopyButton';
import headerImage from './202208_campaign_header.jpg';

const IntroduceCampaign: React.FC = () => (
  <Center flexDirection="column">
    <Box m={{ base: 0, md: 6 }}>
      <img src={headerImage} max-width="85%" alt="友人紹介キャンペーンのロゴ" />
    </Box>

    <Box maxW="600px">
      <Box my={8} mx={6}>
        <Center my={6}>
          <IntroduceUrlCopyButton />
        </Center>

        <Divider />

        <Center>
          <Heading size="md" my={6}>
            キャンペーン内容
          </Heading>
        </Center>

        <Text>
          リケイマッチでは、2022年08月18日より第4回友人紹介キャンペーンを実施することになりました！
          <br />
          <br />
          対象となる学生様の紹介1名につき、ご紹介者へ3,000円、ご友人へ3,000円のAmazonギフトを配付いたします。
          <br />
          <br />
          ご利用中のユーザー（ご紹介者）からのご紹介で、ご友人が初めて「リケイマッチ」をご利用いただくと、ご紹介者にもご友人にも特典が付くキャンペーンです。
          <br />
          <br />
          この機会に周囲で就活に取り組まれているご友人の方々に、リケイマッチをご紹介頂けると運営一同大変嬉しく思います。
          <br />
          <br />
        </Text>

        <Center>
          <Heading size="md" my={6}>
            対象となる学生様
          </Heading>
        </Center>

        <List spacing={3}>
          <ListItem>
            <ListIcon as={CheckIcon} color="blue.500" />
            理系学部卒として就職予定
          </ListItem>
          <ListItem>
            <ListIcon as={CheckIcon} color="blue.500" />
            2024年に卒業見込み
          </ListItem>
          <ListItem>
            <ListIcon as={CheckIcon} color="blue.500" />
            機械、電気電子、情報、物理、数学、化学のいずれかを専攻
          </ListItem>
          <ListItem>
            <ListIcon as={CheckIcon} color="blue.500" />
            登録から10日以内にプロフィール画像を設定
          </ListItem>
          <ListItem>
            <ListIcon as={CheckIcon} color="blue.500" />
            登録から10日以内に学習内容or学生時代に力を入れたこと、いずれか300文字以上を入力
          </ListItem>
        </List>

        <Text>
          <br />
          ※
          今回のキャンペーンでは生物、建築、薬学等は含まないこと、予めご了承ください
          <br />
          <br />
          ※
          以上の条件をすべてを満たしていなければ、キャンペーンの対象となりません
          <br />
          <br />
        </Text>

        <Center>
          <Heading size="md" my={6}>
            紹介方法
          </Heading>
        </Center>

        <Text>
          上記より紹介用のURLをコピーし、お友達に共有してください。
          <br />
          <br />
          10日以内にリケイマッチ運営よりにて紹介条件を確認させていただきます。
          <br />
          <br />
          紹介条件を満たしていることを確認後、ご紹介いただいた方とご友人にAmazonギフト券をメールにて送信させていただきます。
          <br />
          <br />
        </Text>

        <Center>
          <Heading size="md" my={6}>
            お渡しの流れ
          </Heading>
        </Center>

        <UnorderedList spacing={3}>
          <ListItem>
            月末締め、翌月末のお渡しになります。
            <br />※
            例：8月にご紹介頂いた人数×3,000円のアマゾンギフトを、9月末にお渡しします。
          </ListItem>
          <ListItem>
            ご連絡頂いたメールアドレス宛に、お送りさせていただきます。
          </ListItem>
          <ListItem>
            ご友人に対しては、ご友人の登録アドレス宛にお送りさせていただきます。
          </ListItem>
        </UnorderedList>

        <Box bg="#ededed" my={6}>
          <Center>
            <Heading size="md" my={6}>
              ★キャンペーン補足★
            </Heading>
          </Center>
          <Text pb={6} px={6}>
            <b>
              <u>
                この度のキャンペーン経由で200名の方々が集まった場合、もしくは2022年09月30日をもって終了となる予定です。
              </u>
            </b>
            <br />
            <br />
            終了の際にはメール配信にて改めてご連絡させていただきます。
            <br />
            <br />■ 下記の場合、キャンペーン対象にはなりません。
            <UnorderedList spacing={3}>
              <ListItem>
                紹介された方が、リケイマッチに既に登録している場合
              </ListItem>
              <ListItem>
                紹介された方が、Amazonギフト券が配布されるまでまでにリケイマッチを退会した場合
              </ListItem>
              <ListItem>
                紹介した方または紹介された方が、弊社が定める規約などに違反した場合
              </ListItem>
            </UnorderedList>
            <br />■ 注意事項
            <UnorderedList spacing={3}>
              <ListItem>
                Amazonギフト券を得るために、虚偽の登録、プロフィール記入等をした場合は、厳正に対処いたします。
              </ListItem>
            </UnorderedList>
            <br />
            <br />
            リケイマッチは日々、様々な企業様や学生様にご活用頂いています。今後、ユーザー様にとってより良いプロダクトにするべく開発チーム一同、励んで参りたく思います。
          </Text>
        </Box>

        <Text>
          引き続き宜しくお願いいたします。
          <br />
          <br />
          リケイマッチ 運営事務局
          <br />
          メール連絡先:{' '}
          <a href="mailto:contact@cambiainc.co.jp">contact@cambiainc.co.jp</a>
        </Text>
      </Box>
    </Box>
  </Center>
);

export default IntroduceCampaign;
